module.exports = __webpack_public_path__ + "img/dadosabertos.bc35f691.png";